export const USER_CAPTCHA = 'captcha.webp'
export const LOGIN_CODE = 'login'
export const SEND_CODE = 'sendSms'
export const USER_INFO = 'userInfo'

export const LOGIN_ALIPAY = 'loginAlipayByCode'
export const LOGIN_WECHAT = 'loginWechatByUserInfo'
export const LOGIN_FACEBOOK = 'loginFacebookByToken'
export const LOGIN_GOOGLE = 'loginGoogleByCode'

export const JS_CONFIG = 'cdb/setting/js_config'

export const ORDER_LIST = 'cdb/mine/order/list'

export const HELP_LIST = 'cdb/mine/help/list'

export const TX_APPLY = 'cdb/mine/tixian/apply'
export const TX_POST = 'cdb/mine/tixian/create'
